import type { Store } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux';

import type { AppDispatch } from 'app-components/utils/redux-store';
import type RootState from 'app-components/utils/redux-store/rootState';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore = (): Store<RootState> => useStore<RootState>();
